// import LabelWithInfoTooltip from "./Components/InfoToolTips";
// import withRestrictions from "../../Hoc/withRestrictions";
// import withLanguage from "../../Hoc/withLanguage";
// import { useEffect, useState } from "react";

// const TableCell = ({ data , idField ,enableEdit ,editFlag ,isBlured ,tooltip}) => {
// const [fieldId, setFieldId] = useState(null);
// const displayValue = data !== null && data !=="" && data !== undefined ? data : data === 0 ? 0 : "-";

// const shouldEnableEdit = enableEdit && displayValue !== '';

// const borderStyle = isBlured ? '2px dotted #ff1515' : shouldEnableEdit ? '1px solid #ccc' : '';

// const className = [
//     displayValue === "-" ? "" : "counterDiv",
//     shouldEnableEdit ? "enableEdit" : "disableEdit",
//   ]
//     .filter(Boolean) // remove empty strings
//     .join(" ");
// useEffect(() => {
//   if(idField !== null && idField !== undefined && idField !== ""){
//     setFieldId(idField);
//   }
// }, [idField])

//   return (
//     <>
//     {fieldId && (
//  <div
//       id={fieldId}
//       style={{
//         whiteSpace: "pre-wrap",
//         wordBreak: "break-word",
//         border: borderStyle,
//       }}
//       className={className}
//     >
//       {tooltip ? (
//         <LabelWithInfoTooltip info={tooltip} id={fieldId}>
//           {displayValue}
//           <LabelWithInfoTooltip info={tooltip} id={fieldId} color={"#FFBCB3"} />
//         </LabelWithInfoTooltip>
//       ) : (
//         <>
//         {displayValue}
//         </>
//       )}
//     </div>
//     )}
//    </>
//   );
//  };
 
// //  export default withRestrictions(TableCell);

// export default withRestrictions(withLanguage(TableCell));

import LabelWithInfoTooltip from "./Components/InfoToolTips";
import withRestrictions from "../../Hoc/withRestrictions";
import withLanguage from "../../Hoc/withLanguage";
import { useMemo } from "react";

const TableCell = ({ data, idField, enableEdit, editFlag, isBlured, tooltip }) => {
  const displayValue = useMemo(() => {
    if (data === null || data === undefined || data === "") return "-";
    return data;
  }, [data]);

  const shouldEnableEdit =
    enableEdit && data !== null && data !== undefined && data !== "";

  const borderStyle = isBlured
    ? "2px dotted #ff1515"
    : shouldEnableEdit
    ? "1px solid #ccc"
    : "";

  const className = [
    displayValue !== "-" ? "counterDiv" : "",
    shouldEnableEdit ? "enableEdit" : "disableEdit",
  ]
    .filter(Boolean)
    .join(" ");

  // idField is always a stable string derived from the data structure.
  // Using useState+useEffect here caused every cell to render twice on mount
  // (first with null → renders nothing, then effect fires → second render).
  if (!idField) return null;

  return (
    <div
      key={`${idField}-${JSON.stringify(data)}`} // forces update on change
      id={idField}
      style={{
        whiteSpace: "pre-wrap",
        wordBreak: "break-word",
        border: borderStyle,
      }}
      className={className}
    >
      {tooltip ? (
        <LabelWithInfoTooltip info={tooltip} id={idField}>
          {displayValue}
        </LabelWithInfoTooltip>
      ) : (
        displayValue
      )}
    </div>
  );
};

export default withRestrictions(withLanguage(TableCell));

